import { ReferenceInput, SelectInput } from "react-admin";

import React from "react";

const UniversityDepartmentInput = ({ filterValues, ...props }) => (
  <ReferenceInput
    {...props}
    reference="university-departments"
    sort={{ field: "name", order: "ASC" }}
    allowEmpty
    filter={{
      ...filterValues,
    }}
  >
    <SelectInput optionText="name" emptyText="ra.action.all" />
  </ReferenceInput>
);
export default UniversityDepartmentInput;
